export function toError(error: unknown, defaultMessage = 'Unknown error') {
  if (error instanceof Error) return error;
  const message = typeof error === 'string' ? error : defaultMessage;
  return new Error(message, { cause: error });
}
